

























































































































































import { Component, Watch, Prop } from 'vue-property-decorator';
import { CardForm, DialogForm } from '@/components/bwaff';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';
import LoadingCircle from '@/components/loading-circle.vue';

@Component({
  components: {
    CardForm,
    DialogForm,
    LoadingCircle
  }
})
export default class DetailsSubscriptionLimitsBlock extends mixins<PlanLimitsMixin>(
  PlanLimitsMixin
) {
  @Prop()
  api: any;

  @Prop()
  block: {
    name: string;
    nameHelp?: string;
    keys: string[];
  };

  @Prop()
  search: string

  isOpened: boolean = false;

  helpTextMain({key}) {
    switch (key){
      case 'offersAmount':
      case 'affiliateNetworksAmount':
      case 'trafficSourcesAmount':
      case 'flowsAmount':
      case 'landingsAmount':
      case 'campaignsAmount':
        return this.t('Total amount of elements included in plan and add-ons.')
      case 'domainsAmount':
        return this.t('Total amount of tracking domains  included in plan and add-ons');
      case 'redirectDomainsAmount':
        return this.t('Total amount of cloaking domains  included in plan and add-ons.');
      case 'memberAdminsAmount':
        return this.t('Total amount of admin roles included in plan and add-ons.');
      case 'memberUsersAmount':
        return this.t('Total amount of user roles included in plan and add-ons.');
      case 'sharedReportsAmount':
        return this.t('Total amount of shared reports included in plan and add-ons.');
      case 'customColumnsAmount':
        return this.t('Total amount of custom columns included in plan and add-ons.');
      case 'customConversionsAmount':
        return this.t('Total amount of custom conversions included in plan and add-ons.');
      case 'dataRetention':
        return this.t('You can purchase to 12 months of data retention.');
      case 'ivtIpIsDatacenter':
        return this.t('This metric identifies the amount of traffic that comes from the IPs from known data centers, e.g. VPN traffic.');
      case 'ivtIpIsBlacklisted':
        return this.t('This metric identifies the amount of traffic that comes from blacklisted IPs.');
      case 'ivtFastClicker':
        return this.t('This metric allows you to identify clicks on your landing page that are too fast. They have less than 800ms between ad visit and the click on CTA button. Such clicks most likely belong to bots.');
      case 'ivtIpWithFrequentEvents':
        return this.t('This metric allows you to track IPs  that are generating an unusual amount of events, which can be clarified as bot or fraudulent activity.');
      case 'ivtIpWithFrequentCampaignEvents':
        return this.t('This metric is tracking the activity from one IP address within an ad campaign. If the number of events is more than <b>60 per min</b>, traffic from such an IP is marked as suspicious.');
      case 'uniqOfferViewerCondition':
        return this.t('This option redirects the visitor who has already converted to another offer page')
       case 'externalIdCondition':
        return this.t('Allows redirecting visits without an External ID to a selected page.<br>Visits without an External ID may come from previews or bots. By default, BeMob is not accepting this type of  traffic.')
      case 'bulkReportBrowserNames':
      case 'bulkReportBrowserVersions':
      case 'bulkReportCities':
      case 'bulkReportConnectionTypes':
      case 'bulkReportCountries':
      case 'bulkReportDay':
      case 'bulkReportDayOfWeek':
      case 'bulkReportDeviceModels':
      case 'bulkReportDeviceTypes':
      case 'bulkReportDeviceVendors':
      case 'bulkReportHourOfDay':
      case 'bulkReportIp':
      case 'bulkReportIsp':
      case 'bulkReportLanguages':
      case 'bulkReportMobileCarriers':
      case 'bulkReportMonth':
      case 'bulkReportOs':
      case 'bulkReportOsVersions':
      case 'bulkReportReferrerDomains':
      case 'bulkReportReferrers':
      case 'bulkReportScreenResolutions':
      case 'bulkReportStatesRegions':
      case 'bulkReportSubnetBig':
      case 'bulkReportSubnetSmall':
      case 'bulkReportUserAgents':
        return this.t('Available via API requests');
    }
  }

  helpTextIncludedInPlan({key}) {
    switch (key){
    case 'offersAmount':
    case 'affiliateNetworksAmount':
    case 'trafficSourcesAmount':
    case 'flowsAmount':
    case 'landingsAmount':
    case 'campaignsAmount':
      return this.t('Amount of elements included in the current plan.')
    case 'domainsAmount':
      return this.t('Amount of tracking domains included in the current plan.');
    case 'redirectDomainsAmount':
      return this.t('Amount of cloaking domains included in the current plan. ');
    case 'memberAdminsAmount':
      return this.t('Amount of admin roles included in the current plan.');
    case 'memberUsersAmount':
      return this.t('Amount of user roles included in the current plan.');
    case 'sharedReportsAmount':
      return this.t('Amount of shared reports included in the current plan.');
    case 'customColumnsAmount':
      return this.t('Amount of custom columns included in the current plan.');
    case 'customConversionsAmount':
      return this.t('Amount of custom conversions included in the current plan.');
    }
  }

  helpTextAddons({key}) {
    switch (key){
    case 'offersAmount':
    case 'affiliateNetworksAmount':
    case 'trafficSourcesAmount':
    case 'flowsAmount':
    case 'landingsAmount':
    case 'campaignsAmount':
      return this.t('Amount of elements purchased additionally in excess of the plan.')
    case 'domainsAmount':
      return this.t('Amount of tracking domains purchased additionally in excess of the plan.');
    case 'redirectDomainsAmount':
      return this.t('Amount of cloaking domains purchased additionally in excess of the plan.');
    case 'memberAdminsAmount':
      return this.t('Amount of admin roles purchased additionally in excess of the plan.');
    case 'memberUsersAmount':
      return this.t('Amount of user roles purchased additionally in excess of the plan.');
    case 'sharedReportsAmount':
      return this.t('Amount of shared reports purchased additionally in excess of the plan.');
    case 'customColumnsAmount':
      return this.t('Amount of custom columns purchased additionally in excess of the plan.');
    case 'customConversionsAmount':
      return this.t('Amount of custom conversions purchased additionally in excess of the plan.');
    }
  }

  get billing(){
    return this.$store.state.billing
  }

  onClickTitle() {
    this.isOpened = !this.isOpened;
  }

  isAddonPending({key}) {
    return this.billing.addons[key]?.pending || !!this.billing.pending;
  }

  isOnOff({key}) {
    return this.$store.state.billingAddons[key]?.pricing_model==='flat_fee'
  }

  showDetailsForAmountAddon({key}) {
    return this.isOpened && !this.isOnOff({key}) && this.billing.addons[key]
  }

  showManageAddon({key}) {
    return this.$store.getters.planFullData.limits[key] !== true
  }

  addonButtonConfig({key}) {
    const isEnabledAsAddon = this.billing.addons[key]
    if(!isEnabledAsAddon){
      return {
        text:this.t('Buy'),
        icon:'fas fa-badge-dollar',
        buttonStyle:'blue'
      }
    }
    if(isEnabledAsAddon && this.isOnOff({key})){
      return {
        text: this.t('Switch Off'),
        icon:'fas fa-times',
        buttonStyle:'red'
      }
    }
    return {
      text:this.t('Manage'),
      icon:'fas fa-list',
      buttonStyle:'accent'
    }
  }

  openAddonDialog(params:{planLimit:BillingLimits}) {
    this.bus.emit('open-dialog', { name: 'manageAddon',  data: params});
  }
}
